/**
* Auto-generated definitions: manual edits will be lost
*/

// Generated from file: AccountState.cs
export interface AccountState {
    readonly UserName: string;
    readonly IsAdmin: boolean;
    readonly IsObserver: boolean;
    readonly IsCandidate: boolean;
    readonly IsPartyAdmin: boolean;
}

// Generated from file: CandidateState.cs
export enum CandidateEditStatus {
    Saving = 1,
    Success = 2,
    Error = 3,
}

// Generated from file: CandidateState.cs
export interface CandidateNameAndUserNameUpdateModel {
    readonly Name: string;
    readonly UserName: string;
    readonly RowVersion: string;
}

// Generated from file: CandidateState.cs
export interface CandidatePositionUdateModel {
    readonly Position: number;
    readonly RowVersion: string;
}

// Generated from file: CandidateState.cs
export interface CandidateState {
    readonly CandidateId: number;
    readonly ClientSideId: string;
    readonly RowVersion: string;
    readonly PartyId: number;
    readonly ElectionId: number;
    readonly Position: number;
    readonly Name: string;
    readonly Slogan_NL: string;
    readonly Slogan_EN: string;
    readonly ElectionText_NL: string;
    readonly ElectionText_EN: string;
    readonly Avatar?: string;
    readonly HasAvatar: boolean;
    readonly ElectableInOther_NL: string;
    readonly IsCurrentAccountCandidate: boolean;
    readonly UserName: string;
    readonly IsApproved: boolean | null;
    readonly ElectableInOther_EN: string;
    readonly ExtraInfo: string;
    readonly EditStatus?: CandidateEditStatus;
    readonly ModelErrors?: string[];
}

// Generated from file: ClientState.cs
export interface ClientState {
    readonly Type: 'LOADING_STATE' | 'LOGGED_OUT_STATE' | 'LOGGED_IN_STATE' | 'PANIC_STATE';
    readonly Account: AccountState;
    readonly RequestVerificationToken: string;
    readonly ContactMailLink: string;
    readonly ContactWebsiteLink: string;
    readonly ContactPhone: string;
    readonly VoterEntities: VoterEntityState;
    readonly SurfConextFormArgs: SurfConextFormArgs;
    readonly AdminRedirectUrl: string;
    readonly HasCandidacy: boolean | null;
    readonly HasDistributionOfSeats: boolean | null;
    readonly EnableCandidateSlogan: boolean | null;
    readonly EnableCandidateElectableInOthers: boolean | null;
    readonly JustDutch: boolean | null;
}

// Generated from file: PartyAdminState.cs
export interface CreatePartyAdminModel {
    readonly UserName: string;
    readonly PartyId: number;
    readonly PartyAdminId: number;
}

// Generated from file: ElectionHistory.cs
export interface DateTimeSpan {
    readonly From: string;
    readonly Until: string;
}

// Generated from file: ElectionHistory.cs
export interface ElectionOpenSpan {
    readonly Span: DateTimeSpan;
    readonly ElectionId: number;
    readonly Name: Translatable;
    readonly TotalVotingRights: number;
}

// Generated from file: ElectionResult.cs
export interface ElectionResult {
    readonly ElectionResults: ElectionResultLine[];
    readonly BlankVoteCount: number | null;
    readonly VoteCount: number;
    readonly VoterCount: number;
    readonly ElectionName: Translatable;
    readonly IsCandidateSystem: boolean;
}

// Generated from file: ElectionResult.cs
export interface ElectionResultLine {
    readonly CandidateSystem: boolean;
    readonly ElectionCode: string;
    readonly PartyId: number;
    readonly CandidateId: number;
    readonly CandidateName: string;
    readonly PartyName: Translatable;
    readonly VoteCountPerCandidate: number;
    readonly CandidateExtraInfo: string;
    readonly Position: number;
    readonly PartyCode: string;
}

// Generated from file: ElectionState.cs
export interface ElectionState {
    readonly Code: string;
    readonly Name: Translatable;
    readonly Description: Translatable;
    readonly RowVersion: string;
    readonly VisibleFromMoment: string;
    readonly VisibleUntilMoment: string;
    readonly RandomOrderParties: boolean;
    readonly Message?: string;
    readonly ElectionId: number;
    readonly HasLogo: boolean;
    readonly VoteOpenMoment: string;
    readonly VoteCloseMoment: string;
    readonly ElectionStatus: ElectionStatus;
    readonly VoteResult: VoteResult;
    readonly VoterCount: number;
    readonly VoteCount: number;
    readonly SeatCount: number | null;
    readonly UserHasVotingRight: boolean;
    readonly ActuallyInvisible: boolean;
    readonly CandidateSystem: boolean;
    readonly Logo?: string;
    readonly EraseStatus: EraseStatus;
    readonly CandidacyFromMoment: string;
    readonly CandidacyUntilMoment: string;
}

// Generated from file: ElectionState.cs
export enum ElectionStatus {
    CandidacyPeriod = 9,
    NotYetOpen = 10,
    Open = 11,
    Closed = 12,
}

// Generated from file: ElectionState.cs
export enum EraseStatus {
    Started = 0,
    FailedBecauseOpen = 1,
    FailedBecauseRemoved = 2,
    FailedForUnknownReason = 3,
    Succeeded = 4,
    Idle = 5,
}

// Generated from file: ImportResultState.cs
export interface ImportResultState {
    readonly NumberAdded: number;
    readonly NumberUpdated: number;
    readonly Changes: string[];
    readonly FullFreshEntities: VoterEntityState;
}

// Generated from file: PartyAdminState.cs
export interface PartyAdminState {
    readonly UserName: string;
    readonly PartyId: number;
    readonly PartyAdminId: number;
}

// Generated from file: PartyState.cs
export enum PartyEditResult {
    Saving = 1,
    Success = 2,
    Error = 3,
}

// Generated from file: PartyState.cs
export interface PartyPositionUdateModel {
    readonly Position: number;
    readonly RowVersion: string;
}

// Generated from file: PartyState.cs
export interface PartyState {
    readonly PartyId: number;
    readonly ElectionId: number;
    readonly Code: string;
    readonly Name: Translatable;
    readonly Description_NL: string;
    readonly Description_EN: string;
    readonly IsCurrentAccountPartyAdmin: boolean;
    readonly HasURL: boolean;
    readonly RowVersion: string;
    readonly URL?: string;
    readonly ModelErrors?: string[];
    readonly Administrators: string[];
    readonly EditResult?: PartyEditResult;
    readonly Position: number;
    readonly ListOrder: boolean;
}

// Generated from file: PartyUpdate.cs
export interface PartyUpdate {
    readonly RowVersion: string;
    readonly Updates: UpdatableFields;
}

// Generated from file: ConextHelper.cs
export interface SurfConextFormArgs {
    readonly Action: string;
    readonly SAMLRequest: string;
}

// Generated from file: Translatable.cs
export interface Translatable {
    readonly NL: string;
    readonly EN: string;
}

// Generated from file: PartyUpdate.cs
export interface UpdatableFields {
    Name_EN?: string;
    Name_NL?: string;
    Description_EN?: string;
    Description_NL?: string;
    URL?: string;
    ListOrder?: boolean | null;
}

// Generated from file: VoterEntityState.cs
export interface VoterEntityState {
    readonly Candidates: CandidateState[];
    readonly Elections: ElectionState[];
    readonly Parties: PartyState[];
}

// Generated from file: ElectionState.cs
export enum VoteResult {
    NotYetVoted = 20,
    Success = 21,
    FailedElectionClosed = 22,
    FailedAlreadyVoted = 23,
    InProgress = 24,
}

// Generated from file: VotingRightState.cs
export interface VotingRightAccountImportState {
    readonly ElectionCode: string;
    readonly UserName: string;
    readonly VotingRightId: number;
}

import { RequestFactory } from './api';
export const Api = (api: RequestFactory) => ({
    get: api.get,
    Candidates: {
        Avatar<T>(partyId: number, candidatePosition: number, accept?: string) { return api.get<T>(Routes.Candidates.Avatar(partyId, candidatePosition), accept) },
        EditName<T>(partyId: number, position: number, body: {}) { return api.patch<T>(Routes.Candidates.EditName(partyId, position), body) },
        EditPosition<T>(partyId: number, oldPosition: number, body: {}) { return api.patch<T>(Routes.Candidates.EditPosition(partyId, oldPosition), body) },
        AddCandidateWithDummyParty<T>(electionId: number, body: {}) { return api.post<T>(Routes.Candidates.AddCandidateWithDummyParty(electionId), body) },
        Update<T>(body: {}) { return api.post<T>(Routes.Candidates.Update, body) },
        Delete<T>(candidateId: number, body: {}) { return api.post<T>(Routes.Candidates.Delete(candidateId), body) },
        Approve<T>(candidateId: number, body: {}) { return api.post<T>(Routes.Candidates.Approve(candidateId), body) },
        DeleteCandidateSystemCandidate<T>(candidateId: number, partyId: number, body: {}) { return api.post<T>(Routes.Candidates.DeleteCandidateSystemCandidate(candidateId, partyId), body) },
    },
    ConextLogin: {
        ConextLogin<T>(body: {}) { return api.post<T>(Routes.ConextLogin.ConextLogin, body) },
    },
    Elections: {
        VoterUsernamesForElection<T>(electionId: number, accept?: string) { return api.get<T>(Routes.Elections.VoterUsernamesForElection(electionId), accept) },
        Logo<T>(electionId: number, accept?: string) { return api.get<T>(Routes.Elections.Logo(electionId), accept) },
        RemoveLogo<T>(electionId: number, body: {}) { return api.delete<T>(Routes.Elections.RemoveLogo(electionId), body) },
        Update<T>(electionId: number, body: {}) { return api.post<T>(Routes.Elections.Update(electionId), body) },
        Add<T>(body: {}) { return api.post<T>(Routes.Elections.Add, body) },
        EraseElection<T>(electionId: number, body: {}) { return api.delete<T>(Routes.Elections.EraseElection(electionId), body) },
        Get<T>(electionId: number, accept?: string) { return api.get<T>(Routes.Elections.Get(electionId), accept) },
        DownloadVoteResult<T>(electionId: number, accept?: string) { return api.get<T>(Routes.Elections.DownloadVoteResult(electionId), accept) },
        DownloadVoteResults<T>(accept?: string) { return api.get<T>(Routes.Elections.DownloadVoteResults, accept) },
        DownloadTurnoutResults<T>(accept?: string) { return api.get<T>(Routes.Elections.DownloadTurnoutResults, accept) },
        History<T>(accept?: string) { return api.get<T>(Routes.Elections.History, accept) },
        DownloadAllHistoryResults<T>(accept?: string) { return api.get<T>(Routes.Elections.DownloadAllHistoryResults, accept) },
    },
    EmailLogin: {
        Login<T>(accept?: string) { return api.get<T>(Routes.EmailLogin.Login, accept) },
    },
    Export: {
        ExportElectionData<T>(electionId: number, accept?: string) { return api.get<T>(Routes.Export.ExportElectionData(electionId), accept) },
    },
    Home: {
        Index<T>(accept?: string) { return api.get<T>(Routes.Home.Index, accept) },
    },
    Parties: {
        Delete<T>(partyId: number, body: {}) { return api.delete<T>(Routes.Parties.Delete(partyId), body) },
        Patch<T>(partyId: number, body: {}) { return api.patch<T>(Routes.Parties.Patch(partyId), body) },
        Visit<T>(partyId: number, accept?: string) { return api.get<T>(Routes.Parties.Visit(partyId), accept) },
        Add<T>(body: {}) { return api.post<T>(Routes.Parties.Add, body) },
        AddCandidateToParty<T>(partyId: number, body: {}) { return api.post<T>(Routes.Parties.AddCandidateToParty(partyId), body) },
        EditPosition<T>(electionId: number, oldPosition: number, body: {}) { return api.patch<T>(Routes.Parties.EditPosition(electionId, oldPosition), body) },
    },
    PartyAdministrators: {
        MakeVoterPartyAdmin<T>(body: {}) { return api.put<T>(Routes.PartyAdministrators.MakeVoterPartyAdmin, body) },
        AddNewPartyAdmin<T>(body: {}) { return api.post<T>(Routes.PartyAdministrators.AddNewPartyAdmin, body) },
        Validate<T>(accept?: string) { return api.get<T>(Routes.PartyAdministrators.Validate, accept) },
        Delete<T>(body: {}) { return api.delete<T>(Routes.PartyAdministrators.Delete, body) },
    },
    UitslagHanze: {
        ExportZetelVerdeling<T>(electionId: number, accept?: string) { return api.get<T>(Routes.UitslagHanze.ExportZetelVerdeling(electionId), accept) },
    },
    User: {
        SendLoginLink<T>(body: {}) { return api.post<T>(Routes.User.SendLoginLink, body) },
        Logout<T>(body: {}) { return api.post<T>(Routes.User.Logout, body) },
    },
    Vote: {
        Vote<T>(body: {}) { return api.post<T>(Routes.Vote.Vote, body) },
        BlankVote<T>(body: {}) { return api.post<T>(Routes.Vote.BlankVote, body) },
    },
    VotingRights: {
        Parse<T>(body: {}) { return api.post<T>(Routes.VotingRights.Parse, body) },
        AddRange<T>(body: {}) { return api.post<T>(Routes.VotingRights.AddRange, body) },
    },
})
export const Routes = {
    Candidates: {
        Avatar: (partyId: number, candidatePosition: number) => `/api/candidates/${partyId}/${candidatePosition}/avatar/`,
        EditName: (partyId: number, position: number) => `/api/candidates/${partyId}/${position}/`,
        EditPosition: (partyId: number, oldPosition: number) => `/api/candidates/${partyId}/${oldPosition}/position/`,
        AddCandidateWithDummyParty: (electionId: number) => `/api/candidates/${electionId}/add/`,
        Update: `/api/candidates/update/`,
        Delete: (candidateId: number) => `/api/candidates/delete/${candidateId}/`,
        Approve: (candidateId: number) => `/api/candidates/approve/${candidateId}/`,
        DeleteCandidateSystemCandidate: (candidateId: number, partyId: number) => `/api/candidates/deletecandidatesystemcandidate/${candidateId}/${partyId}/`,
    },
    ConextLogin: {
        ConextLogin: `/conextlogin/`,
    },
    Elections: {
        VoterUsernamesForElection: (electionId: number) => `/api/elections/${electionId}/voters/`,
        Logo: (electionId: number) => `/api/elections/${electionId}/logo/`,
        RemoveLogo: (electionId: number) => `/api/elections/${electionId}/logo/`,
        Update: (electionId: number) => `/api/elections/${electionId}/`,
        Add: `/api/elections/`,
        EraseElection: (electionId: number) => `/api/elections/${electionId}/`,
        Get: (electionId: number) => `/api/elections/${electionId}/`,
        DownloadVoteResult: (electionId: number) => `/api/elections/${electionId}/result/`,
        DownloadVoteResults: `/api/elections/results/`,
        DownloadTurnoutResults: `/api/elections/turnoutResults/`,
        History: `/api/elections/history/`,
        DownloadAllHistoryResults: `/api/elections/allHistory/`,
    },
    EmailLogin: {
        Login: `/emaillogin/`,
    },
    Export: {
        ExportElectionData: (electionId: number) => `/api/export/ElectionData/${electionId}/`,
    },
    Home: {
        Index: `/`,
    },
    Parties: {
        Delete: (partyId: number) => `/api/parties/${partyId}/`,
        Patch: (partyId: number) => `/api/parties/${partyId}/`,
        Visit: (partyId: number) => `/api/parties/${partyId}/visit/`,
        Add: `/api/parties/`,
        AddCandidateToParty: (partyId: number) => `/api/parties/${partyId}/candidates/`,
        EditPosition: (electionId: number, oldPosition: number) => `/api/parties/${electionId}/${oldPosition}/position/`,
    },
    PartyAdministrators: {
        MakeVoterPartyAdmin: `/api/partyadministrators/`,
        AddNewPartyAdmin: `/api/partyadministrators/`,
        Validate: `/api/partyadministrators/validate/`,
        Delete: `/api/partyadministrators/`,
    },
    UitslagHanze: {
        ExportZetelVerdeling: (electionId: number) => `/api/hanze/uitslag/${electionId}/`,
    },
    User: {
        SendLoginLink: `/api/user/sendloginlink/`,
        Logout: `/api/user/logout/`,
    },
    Vote: {
        Vote: `/api/vote/vote/`,
        BlankVote: `/api/vote/blankvote/`,
    },
    VotingRights: {
        Parse: `/api/votingrights/parse/`,
        AddRange: `/api/votingrights/`,
    },
}
